import { useClose } from "@headlessui/react";
import { FC } from "react";
import { ConfirmationModalClickWrapper } from "../../../layout/ConfirmationModalClickWrapper";
import { Button, Icon } from "../../../primitives";
import { Menu } from "../../../ui/Menu";

const menuItemClass =
	"flex h-auto w-full items-center justify-start gap-2 rounded-md px-2 py-1.5 text-left text-[13px] font-medium text-secondary hover:bg-surface-dark/55";

type CreditReportActionsMenuProps = {
	testId: string;
	/** Shown in the confirmation before the pull runs. */
	confirmMessage: string;
	onRunCreditReport: () => void;
	runCreditReportPending: boolean;
};

const ActionsMenuPanel: FC<Omit<CreditReportActionsMenuProps, "testId">> = ({
	confirmMessage,
	onRunCreditReport,
	runCreditReportPending,
}) => {
	const close = useClose();

	return (
		<div className="flex shrink-0 flex-col gap-0.5 rounded-md border border-bc-default bg-surface-base px-1 py-1.5">
			<ConfirmationModalClickWrapper
				message={<div className="w-[375px] text-center">{confirmMessage}</div>}
				confirmButtonText="Confirm"
				confirmationButtonColor="primary"
				onConfirm={() => {
					onRunCreditReport();
					close();
				}}
				onCancel={close}
			>
				<Button
					variant="ghost"
					className={menuItemClass}
					disabled={runCreditReportPending}
					leadingIcon={<Icon type="arrow-path" size="small" color="secondary" />}
				>
					Run Credit Report
				</Button>
			</ConfirmationModalClickWrapper>
		</div>
	);
};

export const CreditReportActionsMenu: FC<CreditReportActionsMenuProps> = ({ testId, ...props }) => {
	return (
		<Menu
			testId={testId}
			ariaLabel="Credit report actions"
			button={<Icon type="dots-vertical" size="small" color="tertiary" />}
			buttonClassName="outline-none flex h-6 w-6 shrink-0 items-center justify-center rounded p-0 text-tertiary hover:bg-surface-neutral hover:text-secondary"
			panelClassName="mt-1 bg-surface-base shadow-dropdown-shadow"
			anchor="bottom end"
		>
			<ActionsMenuPanel {...props} />
		</Menu>
	);
};
